goog.require('el8.app.setup');
goog.require('el8.service.tz');
goog.require('el8.service.urls');
goog.require('el8.uiwidget.alert');

var el8 = el8 || {};
if(!el8.main) { el8.main = {}; }
el8.main.appbillingresend = {};

el8.main.appbillingresend.init = function(spec) {
    var that = this;
    el8.app.setup(spec);

    this.from_date = spec['from_date'] || null;
    this.to_date = spec['to_date'] || null;
    this.physicianId = spec['physician_id'] || null;
    this.key = spec["key"] || null;

    $('#page-page-billing-resend').css('overflow-y', 'auto');

    // Trigger
    $(document).on('click', '.resend-btn',  function() {
        var physicianIdorKey = that.physicianId ? that.physicianId: that.key;
        var returnUrl = "/billing/physician/" + physicianIdorKey + "/";

        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('resendWaitingBills', [physicianIdorKey, that.from_date, that.to_date]),
            success: function(data) {
                el8.uiwidget.confirm(
                    'All waiting bills resent. Click to return to Billing.',
                     function () { window.location = returnUrl; },
                     null,
                     null);
            }
        });
    })
};
